import React, { useState } from "react";
import { Row, Col, Alert } from "components/common";
import YourWebsite from "./yourWebsite/YourWebsite";
import CustomWebsite from "./customWebsite/CustomWebsite";
import Recommend from "./recommend/Recommend";
import { Wrapper } from "./ReplicatedPage.styled";
import WebsiteImage from "assets/images/website.jpg";
import BodynbeautyImage from "assets/images/bodynbeauty.jpg"
import { useSelector } from "react-redux";

const websites = [
  {website: 'https://nuevalife.com', image: WebsiteImage},
  {website: 'https://bodynbeauty.com', image: BodynbeautyImage}
]

export default function ReplicatedPage() {
  const [reloadData, setReloadData] = useState(false);
  const myUser = useSelector((state) => state.auth.user);

  const filteredWebsites = websites.filter(site => {
    if (myUser.username === "merchant_nueva") {
      return site.website !== "https://bodynbeauty.com";
    }
    return true;
  });

  return (
    <Wrapper>
      <div className="main-container">
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <Alert
              type="info"
              showIcon
              message={
                <div
                  dangerouslySetInnerHTML={{
                    __html: `Nueva makes it easy for Social Marketers to drive traffic and get credit for sales. Please write down and save your replicated website exactly as it is written. Sending your traffic into the wrong website could result in incorrect enrollments. For questions, please email <a style="text-decoration: none" href="mailto:support@nuevalife.com">support@nuevalife.com</a>.`,
                  }}
                />
              }
              style={{ alignItems: "baseline" }}
            />
          </Col>
          {
            filteredWebsites.map(el => {
              return <Col xs={24} xl={9} xxl={7}>
                <YourWebsite el={el} />
              </Col>

            })
          }
          {/* <Col xs={24} xl={15} xxl={17}>
            <CustomWebsite
              reloadData={reloadData}
              setReloadData={setReloadData}
            />{" "}
          </Col> */}
          {/* <Col span={24}>
            <Recommend />{" "}
          </Col> */}
        </Row>
      </div>
    </Wrapper>
  );
}
